import { MockQuotation } from './quotation.mock';

export const QuoteFactory = {
    mock: () => {
        return new MockQuotation();
    },
};
